module.exports = __webpack_public_path__ + "media/images/partner/teknologi-id-4198364a930e42e87c0ca0e22979e283.png";